// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__-BK_A","question":"styles_question__3yg8-","inputVisibleButton":"styles_inputVisibleButton__2K7VI","note":"styles_note__2RWpB"};